function Q3FinancialHighlightsAnnual() {
	return (
		<div className="not-prose">
			<div className="overflow-x-auto my-6 lg:my-24">
				<table className="is-financial-table">
					<thead>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th colSpan={2} className="!border-r">
								<span className="block leading-[1rem] mb-3">
									Nine Months Ended
									<br /> September 30,
								</span>
							</th>
							<th colSpan={4}>
								<span className="block leading-[1rem]">Years Ended December 31,</span>
							</th>
						</tr>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th>2025</th>
							<th>2024</th>
							<th>2024</th>
							<th>2023</th>
							<th>2022</th>
							<th>2021</th>
						</tr>
						<tr className="no-hover">
							<th>
								<span className="block mb-2 text-left text-[0.75rem] text-black">(billions &ndash; except per share amounts)</span>
							</th>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Net premiums written</td>
							<td>
								<span className="float-left">$</span>
								<span>63.7</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>56.3</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>74.4</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>61.6</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>51.1</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>46.4</span>
							</td>
						</tr>
						<tr>
							<td className="cell-indent">Growth over prior period</td>
							<td>13%</td>
							<td>21%</td>
							<td>21%</td>
							<td>20%</td>
							<td>10%</td>
							<td>14%</td>
						</tr>
						<tr>
							<td>Net premiums earned</td>
							<td>
								<span className="float-left">$</span>
								<span>60.6</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>51.7</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>70.8</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>58.7</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>49.2</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>44.4</span>
							</td>
						</tr>
						<tr>
							<td className="cell-indent">Growth over prior period</td>
							<td>17%</td>
							<td>20%</td>
							<td>21%</td>
							<td>19%</td>
							<td>11%</td>
							<td>13%</td>
						</tr>
						<tr className="">
							<td>Total revenues</td>
							<td>
								<span className="float-left">$</span>
								<span>64.9</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>55.1</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>75.4</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>62.1</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>49.6</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>47.7</span>
							</td>
						</tr>
						<tr>
							<td>Net income</td>
							<td>
								<span className="float-left">$</span>
								<span>8.4</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>6.1</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>8.5</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>3.9</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>0.7</span>
							</td>
							<td>
								<span className="float-left">$</span>
								<span>3.4</span>
							</td>
						</tr>
						<tr>
							<td className="cell-indent">Per common share</td>
							<td>
								<span className="float-left">$</span>14.21
							</td>
							<td>
								<span className="float-left">$</span>10.39
							</td>
							<td>
								<span className="float-left">$</span>14.40
							</td>
							<td>
								<span className="float-left">$</span>
								<span>6.58</span>
							</td>
							<td>
								<span className="float-left">$</span>1.18
							</td>
							<td>
								<span className="float-left">$</span>5.66
							</td>
						</tr>
						<tr>
							<td>Underwriting margin</td>
							<td>12.7%</td>
							<td>10.9%</td>
							<td>11.2%</td>
							<td>5.1%</td>
							<td>4.2%</td>
							<td>4.7%</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div className="overflow-x-auto my-0 lg:my-24">
				<table className="is-financial-table">
					<thead>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th colSpan={2} className="!border-r">
								<span className="block leading-[1rem] mb-3">
									Nine Months Ended
									<br /> September 30,
								</span>
							</th>
							<th colSpan={4}>
								<span className="block leading-[1rem]">Years Ended December 31,</span>
							</th>
						</tr>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th>2025</th>
							<th>2024</th>
							<th>2024</th>
							<th>2023</th>
							<th>2022</th>
							<th>2021</th>
						</tr>
						<tr className="no-hover">
							<th>
								<span className="block text-[#767727]">At Period-End</span>
							</th>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<th colSpan={1}>
								<span className="block mb-2 text-left text-[0.75rem] text-black leading-[1.6]">(billions &ndash; except shares outstanding, per share amounts, and policies in force)</span>
							</th>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Common shares outstanding (millions)</td>
							<td>586.4</td>
							<td>585.8</td>
							<td>585.8</td>
							<td>585.3</td>
							<td>584.9</td>
							<td>584.4</td>
						</tr>
						<tr>
							<td>Book value per common share</td>
							<td>
								<span className="float-left">$</span>60.45
							</td>
							<td>
								<span className="float-left">$</span>46.36
							</td>
							<td>
								<span className="float-left">$</span>43.69
							</td>
							<td>
								<span className="float-left">$</span>33.80
							</td>
							<td>
								<span className="float-left">$</span>26.32
							</td>
							<td>
								<span className="float-left">$</span>30.35
							</td>
						</tr>
						<tr>
							<td>Consolidated shareholders&apos; equity</td>
							<td>
								<span className="float-left">$</span>35.4
							</td>
							<td>
								<span className="float-left">$</span>27.2
							</td>
							<td>
								<span className="float-left">$</span>25.6
							</td>
							<td>
								<span className="float-left">$</span>20.3
							</td>
							<td>
								<span className="float-left">$</span>15.9
							</td>
							<td>
								<span className="float-left">$</span>18.2
							</td>
						</tr>
						<tr>
							<td>Common share close price</td>
							<td>
								<span className="float-left">$</span>246.95
							</td>
							<td>
								<span className="float-left">$</span>253.76
							</td>
							<td>
								<span className="float-left">$</span>239.61
							</td>
							<td>
								<span className="float-left">$</span>159.28
							</td>
							<td>
								<span className="float-left">$</span>129.71
							</td>
							<td>
								<span className="float-left">$</span>102.65
							</td>
						</tr>
						<tr>
							<td>Market capitalization</td>
							<td>
								<span className="float-left">$</span>144.8
							</td>
							<td>
								<span className="float-left">$</span>148.7
							</td>
							<td>
								<span className="float-left">$</span>140.4
							</td>
							<td>
								<span className="float-left">$</span>93.2
							</td>
							<td>
								<span className="float-left">$</span>75.9
							</td>
							<td>
								<span className="float-left">$</span>60.0
							</td>
						</tr>
						<tr>
							<td>
								Return on average common shareholders’
								<br /> equity – trailing 12 months
							</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Net income</td>
							<td>35.9%</td>
							<td>37.5%</td>
							<td>35.5%</td>
							<td>22.9%</td>
							<td>4.4%</td>
							<td>18.6%</td>
						</tr>
						<tr>
							<td className="cell-indent">Comprehensive income (loss)</td>
							<td>37.1%</td>
							<td>50.9%</td>
							<td>36.4%</td>
							<td>30.0%</td>
							<td>(13.5)%</td>
							<td>13.6%</td>
						</tr>
						<tr className="h-[3.75rem] no-hover">
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>Policies in force (thousands)</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Personal Lines</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent--2">Agency &ndash; auto</td>
							<td>10,630</td>
							<td>9,415</td>
							<td>9,778</td>
							<td>8,336</td>
							<td>7,767</td>
							<td>7,879</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Direct &ndash; auto</td>
							<td>15,619</td>
							<td>13,388</td>
							<td>13,996</td>
							<td>11,190</td>
							<td>10,131</td>
							<td>9,568</td>
						</tr>
						<tr className="">
							<td className="cell-indent--2">Special lines</td>
							<td>6,980</td>
							<td>6,475</td>
							<td>6,520</td>
							<td>5,969</td>
							<td>5,558</td>
							<td>5,289</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent--2">Property</td>
							<td>3,651</td>
							<td>3,460</td>
							<td>3,517</td>
							<td>3,096</td>
							<td>2,851</td>
							<td>2,776</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent--3">Total Personal Lines</td>
							<td>36,880</td>
							<td>32,738</td>
							<td>33,811</td>
							<td>28,591</td>
							<td>26,307</td>
							<td>25,512</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent--4">Growth over prior period</td>
							<td>13%</td>
							<td>15%</td>
							<td>18%</td>
							<td>9%</td>
							<td>3%</td>
							<td>7%</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent">Commercial Lines</td>
							<td>1,198</td>
							<td>1,131</td>
							<td>1,141</td>
							<td>1,099</td>
							<td>1,046</td>
							<td>971</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent--4">Growth over prior period</td>
							<td>6%</td>
							<td>2%</td>
							<td>4%</td>
							<td>5%</td>
							<td>8%</td>
							<td>18%</td>
						</tr>
						<tr>
							<td className="cell-indent">Companywide total</td>
							<td className="border-b-[2px] border-[#BFBFBF]">38,078</td>
							<td className="border-b-[2px] border-[#BFBFBF]">33,869</td>
							<td className="border-b-[2px] border-[#BFBFBF]">34,952</td>
							<td className="border-b-[2px] border-[#BFBFBF]">29,690</td>
							<td className="border-b-[2px] border-[#BFBFBF]">27,353</td>
							<td className="border-b-[2px] border-[#BFBFBF]">26,483</td>
						</tr>
						<tr className="border-b-[1px] border-[#BFBFBF]">
							<td className="cell-indent--4">Growth over prior period</td>
							<td>12%</td>
							<td>14%</td>
							<td>18%</td>
							<td>9%</td>
							<td>3%</td>
							<td>7%</td>
						</tr>
						<tr className="h-[2.16rem] no-hover">
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>
								Private passenger auto insurance market
								<sup>1</sup>
							</td>
							<td>
								<span>|||||||||||||</span>
							</td>
							<td>
								<span>|||||||||||||</span>
							</td>
							<td>
								<span className="float-left">$</span>345.9
							</td>
							<td>
								<span className="float-left">$</span>306.6
							</td>
							<td>
								<span className="float-left">$</span>268.0
							</td>
							<td>
								<span className="float-left">$</span>252.9
							</td>
						</tr>
						<tr>
							<td>
								Market share<sup>2</sup>
							</td>
							<td>
								<span>|||||||||||||</span>
							</td>
							<td>
								<span>|||||||||||||</span>
							</td>
							<td>17.2%</td>
							<td>15.6%</td>
							<td>14.4%</td>
							<td>14.1%</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div className="overflow-x-auto my-0 lg:my-24">
				<table className="is-financial-table">
					<thead>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th colSpan={2} className="!border-r">
								<span className="block leading-[1rem] mb-3">
									Nine Months Ended
									<br /> September 30,
								</span>
							</th>
							<th colSpan={4}>
								<span className="block leading-[1rem]">Years Ended December 31,</span>
							</th>
						</tr>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>
							<th>2025</th>
							<th>2024</th>
							<th>2024</th>
							<th>2023</th>
							<th>2022</th>
							<th>2021</th>
						</tr>
						<tr className="no-hover">
							<th>
								<span className="block text-[#767727]">
									Stock Price Appreciation (Depreciation)<sup>3</sup>
								</span>
							</th>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Progressive</td>
							<td>5.2%</td>
							<td>60.3%</td>
							<td>51.4%</td>
							<td>23.2%</td>
							<td>26.8%</td>
							<td>10.8%</td>
						</tr>
						<tr>
							<td>S&amp;P 500</td>
							<td>14.8%</td>
							<td>22.1%</td>
							<td>25.0%</td>
							<td>26.3%</td>
							<td>(18.1)%</td>
							<td>28.7%</td>
						</tr>
					</tbody>
				</table>
				<div className="mt-10 text-[.85rem] leading-[1.6] tabular-nums">
					<p className="mb-0 no-animate">
						<sup>1</sup> Represents net premiums written as reported by A.M. Best Company, Inc.
					</p>
					<p className="mb-0 no-animate">
						<sup>2</sup> Represents Progressive’s private passenger auto business, including motorcycle insurance, as a percent of the private passenger auto insurance market.
					</p>
					<p className="mb-0 no-animate">
						<sup>3</sup> Represents average compounded rate of increase (decrease) and assumes dividend reinvestment.
					</p>
				</div>
			</div>
		</div>
	);
}

export default Q3FinancialHighlightsAnnual;
